// src/services/api/offlineSales/cheques.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/cheque.routes.js
import { apiClient } from '../base';

export const getCheques = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/cheques', { params });
  return response.data;
};

export const getChequeSummary = async () => {
  const response = await apiClient.get('/offline-sales/cheques/summary');
  return response.data;
};

export const updateChequeStatus = async (id, status) => {
  const response = await apiClient.patch(`/offline-sales/cheques/${id}/status`, { status });
  return response.data;
};
